import React, { Profiler } from 'react';
import track from 'react-tracking';
import 'App.css';
import Dashboard from 'Components/Dashboard/Dashboard';
import { createUTagTrackingOptions, createUTagTrackingPayload } from 'tracking/useUTag';
import onRenderCallback from 'tracking/onRenderCallback';

function App(props) {
    return (
        <Profiler id="Dashboard" onRender={onRenderCallback}>
            <Dashboard {...props} />
        </Profiler>
    );
};

const TrackedApp = track(createUTagTrackingPayload(), createUTagTrackingOptions())(App);

export default TrackedApp;
